import React, { Fragment } from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { ToolbarButton, Toolbar, ToolbarButtonGroup } from 'neon-design-system';
import { PremiumChannelKind, PremiumChannelType, premiumChannelLabel } from '../../../shared/global-enums';

const useStyles = makeStyles(theme => createStyles({
	headingCaption: {
		display: 'flex',
		justifyContent: 'space-between'
	}
}));

export interface PremiumChannelsFilterProps {
	premiumChannelKind: PremiumChannelKind;
	setPremiumChannelKind: (value: PremiumChannelKind) => void;
	channelType: PremiumChannelType;
	setChannelType: (value: PremiumChannelType) => void;
}

const PremiumChannelsFilter = (props: PremiumChannelsFilterProps) => {
	const classes = useStyles();

	return (
		<Fragment>
			<Toolbar
				id="premium-channels-toolbar"
				className={classes.headingCaption}>
				<ToolbarButtonGroup>
					{
						Object.keys(PremiumChannelKind).map((item, i: number) =>
							<ToolbarButton
								key={i}
								text={premiumChannelLabel[item as PremiumChannelKind]}
								selected={props.premiumChannelKind === item}
								onClick={() => props.setPremiumChannelKind(item as PremiumChannelKind)}
							/>
						)}
				</ToolbarButtonGroup>
				<ToolbarButtonGroup>
					{
						Object.values(PremiumChannelType).map((item, i: number) =>
							<ToolbarButton
								key={i}
								text={item}
								selected={props.channelType === item}
								onClick={() => props.setChannelType(item as PremiumChannelType)}
							/>
						)}
				</ToolbarButtonGroup>
			</Toolbar>
		</Fragment>
	);
};

export default PremiumChannelsFilter;
